import { bridgeCall, bridgeCallAsync, BridgeParams } from './bridge'

export const BridgeGetAccessToken = async (force = false): Promise<string> => {
  const token: any = await bridgeCallAsync('Auth.requestAuthToken', {
    arguments: force,
  })
  return token.accessToken
}

export const bridgeData = {
  bridgeAppReady: false,
}

export const BridgeAppReady = () => {
  bridgeCall('Webapp.ready')
  bridgeData.bridgeAppReady = true
}

export const BridgeLogout = () => {
  bridgeCall('Auth.logOut')
}

export const BridgeUpdateToken = (params?: BridgeParams, finalName?: string) => {
  bridgeCall('Auth.updateAuthToken', params, finalName)
}

export const BridgeRouteRedirect = (params?: BridgeParams, finalName?: string) => {
  bridgeCall('Route.redirect', params, finalName)
}

export const BridgeSwitchSchool = () => {
  bridgeCall('Tea.switchSchool')
}
